export default function() {return(
	<svg stroke={'white'} width={38} height={19} xmlns="http://www.w3.org/2000/svg" style={{rotate: "-45deg"}}>
		<rect x="2" y="1" width="16" height="13" rx="5" ry="5" fill="none" strokeWidth="1"></rect>
		<rect x="14" y="5" width="16" height="13" rx="5" ry="5" fill="none" strokeWidth="1"></rect>
	</svg>
)}